import type { TaskStatusType } from '@frontend/api-types';
import { P, match } from '@frontend/duck-tape';

export const canReviewOptionSheet = (taskStatus: TaskStatusType) =>
  match(taskStatus)
    .with(P.union('new', 'open', 'solved', 'pending', 'snoozed', 'on_hold', 'draft'), () => true)
    .with('archived', () => false)
    .exhaustive();
